import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import "@sendbird/uikit-react/dist/index.css";
import { useMentorView } from "@/lib/hooks/admin/use-mentor-view.ts";
import { Dashboard } from "@/components/dashboard";
import { MentorDataDashboard } from "@/components/mentor-data-dashboard";
import { PostHogEvents, useTrackPage } from "@/lib/posthog-events";
import { useAbility } from "@/lib/casl/ability-context";

const searchSchema = z
  .object({
    mentorId: z.preprocess(
      (value) => (value === "" || value === "all" ? undefined : value),
      z.string().uuid().optional(),
    ),
  })
  .passthrough();

export const Route = createFileRoute("/_authenticated/")({
  component: Root,
  validateSearch: searchSchema,
});

function Root() {
  const mentorView = useMentorView((state) => state.mentorView);
  useTrackPage(PostHogEvents.PAGE_HOME);

  const ability = useAbility();
  const canViewAdminDashboard = ability.can("read", "admin-analytics");

  return !mentorView && canViewAdminDashboard ? (
    <Dashboard />
  ) : (
    <MentorDataDashboard />
  );
}
